<template>
  <div
    v-if="loading"
    v-loading="loading"
    class="main_outer"
    style="position:absolute;top:55px;width: 100%;height: calc(100% - 55px);"
  />
  <div v-else-if="homeLink">
    <iframe
      id="mobsf"
      :src="homeLink"
      frameborder="0"
      style="position:absolute;top:55px;width: 100%;height: calc(100% - 55px);"
    />
  </div>
  <el-row
    v-else
    class="main_container_outer"
  >
    <el-row class="main_container body-wbq">
      <el-col :span="8" class="content_top_banner">

        <div class="top_banner_content">
          <div class="hint_head">欢迎使用融创大数据服务平台</div>
          <div class="hint_content">公司提供：数据查询、信息推送、接口查询、接口服务。</div>
        </div>


      </el-col>
    </el-row>
    <el-row>


      <div class="product-list">
        <el-card v-for="product in products" :key="product.name" class="product-card">
          <div slot="header" class="product-card-header">{{ product.name }}</div>
          <div class="product-card-content">
            <img :src="product.img" alt="Product Image" class="product-image" />
            <p>{{ product.description }}</p>
            <a :href="product.link" target="_blank" class="product-link">详情</a>
          </div>
        </el-card>
      </div>





    </el-row>

  </el-row>
</template>

<script>

import {blogLastActive} from '@/api/wizard/wizard'


export default {
  name: 'Wizard',
  components: {},
  data() {
    return {

      products:[
        {
          name:'税务大屏',
          background:'linear-gradient(180deg, rgba(115,231,168,0.9) 0%, rgba(115,231,168,0.4) 100%)',
          link:'http://service.1.ink/',
          img:require('@/assets/swdp.png')

        },
        {
          name: '知识产权中心',
          background:'linear-gradient(180deg, rgba(244,207,121,0.9) 0%, rgba(244,207,121,0.4) 100%)',
          link:'https://wwww.xjip.info/',
          img:require('@/assets/zscq.png')
        },
        {
          name:'信息通道',
          background: 'linear-gradient(180deg, rgba(244,121,121,0.9) 0%, rgba(244,121,121,0.4) 100%)',
          link:'https://wwww.1.ink/',
          img:require('@/assets/xxtd.png')
        },

        {
          name:'矿产权人查询',
          background:'linear-gradient(180deg, rgba(115,231,168,0.9) 0%, rgba(115,231,168,0.4) 100%)',
          link:'https://chain.1.ink/',
          img:require('@/assets/kcqr.png')

        },
        {
          name: '高新技术企业',
          background:'linear-gradient(180deg, rgba(244,207,121,0.9) 0%, rgba(244,207,121,0.4) 100%)',
          link:'https://chain.1.ink/',
          img:require('@/assets/gqcx.png')
        },
        {
          name:'公司大屏',
          background: 'linear-gradient(180deg, rgba(244,121,121,0.9) 0%, rgba(244,121,121,0.4) 100%)',
          link:'https://1.ink/screen',
          img:require('@/assets/gscp.png')
        }
      ],
      loading: true

    }
  },
  computed: {
    homeLink() {
      if (this.$store.getters.uiInfo && this.$store.getters.uiInfo['ui.homeLink'] && this.$store.getters.uiInfo['ui.homeLink'].paramValue) {
        return this.$store.getters.uiInfo['ui.homeLink'].paramValue
      }
      return null
    }
  },
  mounted() {
    setTimeout(() => {
      this.loading = false
    }, 1000)
  },

  created() {
    this.init()
  },
  methods: {
    showBigImage(src){
      this.$alert('<img src="'+src+'" style="width: 780px;height: auto;min-height:300px;object-fit: contain;object-position: center;"/>', '大图', {
        dangerouslyUseHTMLString: true,

        showConfirmButton:false,
        showCancelButton:false,
        customClass:'big-image'
      });
    },
    init() {
      blogLastActive().then(res => {
        this.blogsInfo = res.data
      })
    }
  }
}

</script>
<style scoped>

</style>
<style lang="scss" scoped>
.main_outer {
  background-color: var(--MainBG, #f5f6f7)
}

.main_container {
  min-width: 1250px;
  padding: 0 24px 0 24px;
  position: relative;
  display: flex;
  align-items: center;
  overflow: hidden;
  justify-content: center;
  background-size: 100% 444px !important;
  background: url('../../assets/wizard_main_bg.png') no-repeat;
}

.main_content {
  width: 1920px;
}

.product-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  max-width: 1920px;
  margin: 0 auto;

  .product-card {
    width: calc(33.33% - 20px); /* 计算每个卡片的宽度，减去间距 */
    margin-bottom: 20px; /* 底部间距 */

    .product-card-header {
      font-size: 18px;
      font-weight: bold;
    }

    .product-card-content {
      padding: 10px;

      .product-image {
        width: 100%; /* 让图片宽度填满容器 */
        height: 200px; /* 设置图片的高度 */
        object-fit: cover; /* 保持宽高比，隐藏多余部分 */
        margin-bottom: 10px;
      }

      .product-link {
        display: inline-block;
        margin-top: 10px;
      }
    }
  }
}


.content_top_banner {
  color: var(--ContentBG, #FFFFFF);
  position: relative;
  width: 100%;
  height: 230px;
}

.top_banner_content {
  position: absolute;
  top: 62px;
  height: 230px;
}

.top_banner_img {
  position: absolute;
  width: 520px;
  height: 230px;
  top: 0;
  right: 50px;
}

.top_banner_card {
  position: relative;
  width: 100%;
  height: 214px;
}

.hint_head {
  line-height: 48px;
  font-weight: 600;
  font-size: 48px;
}

.hint_content {
  margin-top: 12px;
  line-height: 26px;
  font-weight: 400;
  font-size: 18px;
}

.content_middle {
  height: 290px;
  width: 100%;
  margin-top: 24px;
}

.content_middle_left {
  float: left;
  width: 792px;
  height: 290px;
  padding: 24px;
  border-radius: 4px;
  background-color: var(--ContentBG, #FFFFFF);
}

.content_middle_title {
  float: left;
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 38px;
  color: var(--TextPrimary, #1F2329);
}

.content_middle_more {
  float: right;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  color: #646A73;
  border-radius: 4px;
  height: 26px;
  padding: 2px;

  &:hover {
    background: rgba(31, 35, 41, 0.1);
    cursor: pointer;
  }
}

.content_middle_more i:hover {
  background: none;
}

.content_middle_more a:hover {
  background: none;
}

.content_middle_right {
  float: left;
  height: 290px;
  width: 384px;
  margin-left: 24px;
  padding: 24px;
  border-radius: 4px;
  background-color: var(--ContentBG, #FFFFFF);
}

.content_middle_left {
  float: left;
  width: 792px;
  height: 290px;
  padding: 24px;
  border-radius: 4px;
  background-color: var(--ContentBG, #FFFFFF);
}

.li-custom {
  margin-top: 16px;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  list-style-type: disc;
  list-style-position: inside;
  border-radius: 4px;
  padding-left: 12px;
  margin-left: -12px;

  &:hover {
    background: rgba(31, 35, 41, 0.1);
    cursor: pointer;
    color: #3370FF !important;

    .li-a {
      color: #3370FF !important;
    }
  }
}

.li-custom a:hover {
  background: none;
}

.li-a {
  color: var(--TextPrimary, #1F2329);
}

.ul-custom {
  padding-inline-start: 0px;
  color: #8F959E;
}

.content_bottom {
  width: 100%;
  height: 208px;
}

.content_bottom_contact {
  float: left;
  margin-left: 278px;
  width: 200px;
  margin-top: 40px;
}

.contact_title {
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: var(--TextPrimary, #1F2329);
  margin-bottom: 16px;
}

.contact_content {
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: #646A73;
  margin-top: 8px;
}

.contact_content a:hover {
  color: #3370FF;
}

.content_bottom_qr_code {
  width: 500px;
  float: right;
  text-align: right;
  margin-right: 180px;
  margin-top: 40px;
  padding-right: 100px;
}

.contact_title_qr {
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  text-align: center;
  color: #646A73;
  margin-bottom: 8px;
}

.contact_wechat_train {
  width: 100px;
  float: right;
}

.contact_wechat_train_img {
  box-sizing: border-box;
  width: 100px;
  height: 100px;
  border: 2px solid #FFFFFF;
}

.contact_wechat_official {
  width: 100px;
  float: right;
  margin-right: 40px;
}

.contact_wechat_official_img {
  box-sizing: border-box;
  width: 100px;
  height: 100px;
  border: 2px solid #FFFFFF;
}

.contact_wechat_group {
  width: 100px;
  float: right;
  margin-right: 40px;
}

.contact_wechat_group_img {
  box-sizing: border-box;
  width: 100px;
  height: 100px;
  border: 2px solid #FFFFFF;
}

.main_container_outer {
  width: 100%;
  height: calc(100vh - 56px);
  background-color: var(--MainBG, #f5f6f7);
  overflow: auto;
}
.border-box{
  box-sizing: border-box;
}
.center {
  width: 1920px;
  overflow: hidden;
  margin: 0 auto;
  height:1000px;
  .el-card{
    margin:24px;
  }
  .bg-image {
    //上到下渐变
    background-color: #316bf232;
    padding: 24px;
    font-size: 24px;
    height: 300px;
    width: 100%;
    box-sizing: border-box;
    color: #2c3e50;
    overflow: hidden;


    margin-top: 20px;
  }
      .bottom {
        line-height: 30px;
        box-sizing: border-box;
        background-color: #fff;
        height: 50px;
        padding: 24px;
        width: 100%;
      }



}
</style>
